<div class="side-nav__footer">
    <core-dark-mode-toggle></core-dark-mode-toggle>
    <!--          <a class="btn btn-circle btn-circle&#45;&#45;profile" *ngIf="isLoggedIn && authenticationType === 'individual'"-->
    <!--             (click)="hamburger = !hamburger" routerLink="/profile">-->
    <!--            {{'Profile' | translate}}-->
    <!--            <svg width="20" height="20">-->
    <!--              <g fill="#FFF" fill-rule="nonzero">-->
    <!--                <path-->
    <!--                  d="M10 10.77a5.39 5.39 0 0 0 5.385-5.394A5.376 5.376 0 0 0 10 0a5.386 5.386 0 0 0-5.385 5.376c0 2.961 2.412 5.393 5.385 5.393zm0-9.364a3.979 3.979 0 0 1 3.964 3.97A3.979 3.979 0 0 1 10 9.346a3.979 3.979 0 0 1-3.964-3.97A3.979 3.979 0 0 1 10 1.406zM.706 20h18.588a.714.714 0 0 0 .706-.732c0-3.829-3.005-6.96-6.716-6.96H6.716C3.02 12.308 0 15.422 0 19.268c0 .409.312.732.706.732zm6.01-6.229h6.568c2.693 0 4.91 2.077 5.255 4.765H1.46c.345-2.671 2.562-4.765 5.255-4.765z"/>-->
    <!--              </g>-->
    <!--            </svg>-->
    <!--          </a>-->
    <a
        (click)="hamburger = !hamburger"
        [core-analytics]="{ action: 'Help & Support', category: 'SIDE-NAV' }"
        class="btn btn-circle btn-circle--info"
        routerLink="/contact">
        {{ 'Help & Support' | translate }}
        <svg width="20" height="20">
            <g fill="#FFF" fill-rule="nonzero">
                <circle cx="10" cy="14.785" r="1" />
                <path
                    d="M10 0C4.473 0 0 4.473 0 10s4.473 10 10 10 10-4.473 10-10S15.527 0 10 0zm0 18.438A8.433 8.433 0 0 1 1.562 10 8.433 8.433 0 0 1 10 1.562 8.433 8.433 0 0 1 18.438 10 8.433 8.433 0 0 1 10 18.438z" />
                <path
                    d="M10 5.02a3.129 3.129 0 0 0-3.125 3.125.781.781 0 1 0 1.563 0c0-.862.7-1.563 1.562-1.563.862 0 1.563.701 1.563 1.563 0 .861-.701 1.562-1.563 1.562a.781.781 0 0 0-.781.781v1.953a.781.781 0 1 0 1.562 0v-1.27a3.13 3.13 0 0 0 2.344-3.026A3.129 3.129 0 0 0 10 5.02z" />
            </g>
        </svg>
    </a>
    @if (isLoggedIn) {
        <a
            (click)="logout()"
            [core-analytics]="{ action: 'Logout', category: 'SIDE-NAV' }"
            class="btn btn-circle btn-circle--logout"
            href="javascript:void(0);">
            {{ 'Logout' | translate }}
            <svg width="17" height="18">
                <g fill="#FFF" fill-rule="nonzero">
                    <path
                        d="M12.92 4.512a.838.838 0 0 0-1.163 0 .788.788 0 0 0 0 1.134l2.435 2.374H4.113a.813.813 0 0 0-.823.802c0 .443.369.802.823.802h10.079l-2.435 2.374a.788.788 0 0 0 0 1.134.83.83 0 0 0 .582.235.83.83 0 0 0 .581-.235l3.839-3.743a.788.788 0 0 0 0-1.134L12.92 4.512z" />
                    <path
                        d="M7.952 17.644c.454 0 .822-.359.822-.802a.813.813 0 0 0-.822-.802H1.645V1.604h6.307c.454 0 .822-.36.822-.802A.813.813 0 0 0 7.952 0H.822A.813.813 0 0 0 0 .802v16.04c0 .443.368.802.823.802h7.129z" />
                </g>
            </svg>
        </a>
    }
</div>
